import { dropRight } from 'es-toolkit';

import { getActiveComponentDesignGuid } from '../selectors/getActiveComponentDesignSelector';
import { getUserDistanceDimensions } from '../selectors/getUserDistanceDimensions';
import { setUserDistanceDimensions } from '../slices/componentDesignsSlice';
import { clearLocalUserDistanceDimensions, deleteNewestLocalUserDimension } from '../slices/localUserDimensionsSlice';
import { AsyncThunkActionVoid } from './thunkActions';

export const saveUserDimensions = (): AsyncThunkActionVoid => async (dispatch, getState) => {
  const state = getState();
  const activeComponentDesignGuid = getActiveComponentDesignGuid(state);
  if (!activeComponentDesignGuid) throw new Error('Cannot save user dimensions without an active component design');
  const userDistanceDimensions = getUserDistanceDimensions(state);

  dispatch(setUserDistanceDimensions({ componentDesignGuid: activeComponentDesignGuid, userDistanceDimensions }));
  dispatch(clearLocalUserDistanceDimensions());
};

export const deleteNewestUserDimension = (): AsyncThunkActionVoid => async (dispatch, getState) => {
  const state = getState();
  const { localUserDimensions } = state;
  const activeComponentDesignGuid = getActiveComponentDesignGuid(state);
  if (!activeComponentDesignGuid) throw new Error('Cannot save user dimensions without an active component design');
  const userDistanceDimensions = getUserDistanceDimensions(state);

  if (localUserDimensions.length > 0) {
    dispatch(deleteNewestLocalUserDimension());
    return;
  }

  const updatedUserDistanceDimensions = dropRight(userDistanceDimensions, 1);
  dispatch(
    setUserDistanceDimensions({
      componentDesignGuid: activeComponentDesignGuid,
      userDistanceDimensions: updatedUserDistanceDimensions,
    }),
  );
};
